<template>
  <div v-if="isLoaded">
    <div
        class="content-body"
        v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Montagem de Carga</h4>
              <a class="heading-elements-toggle"
              ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
              ></i
              ></a>
              <div
                  class="heading-elements"
                  v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                        @click="onEditTransportadoraLote()"
                        v-b-tooltip
                        title="Alterar Transportadora em lote"
                        v-if="
                        getPermissionFw('montagemcarga.alterartransportadora')
                      "
                    ><i class="fa fa-truck"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="onStore()"
                        v-b-tooltip
                        title="Cadastrar"
                        v-if="getPermissionFw('montagemcarga.store')"
                    ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="onCreate(null, 1)"
                        v-b-tooltip
                        title="Escanear Código"
                        v-if="getPermissionFw('montagemcarga.store')"
                    ><i class="fa fa-barcode"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="onFilterReset()"
                        v-b-tooltip
                        title="Atualizar listagem"
                    ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="expandFullscreenFw()"
                        v-b-tooltip
                        title="Expande a tela"
                        v-if="!isFullscreen"
                    ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="expandFullscreenFw()"
                        v-b-tooltip
                        title="Minimiza a tela"
                        v-if="isFullscreen"
                    ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="onFilterShowHideFw()"
                        v-b-tooltip.hover.left="'Filtros'"
                    ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="onActivateDesactivate(1, null, false)"
                        v-b-tooltip
                        title="Ativar Registros"
                        v-if="getPermissionFw('montagemcarga.status')"
                    ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="onActivateDesactivate(2, null, false)"
                        v-b-tooltip
                        title="Inutilizar Registros"
                        v-if="getPermissionFw('montagemcarga.status')"
                    ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'doc_fiscal'">
                  </vuetable-filterbar>
                </div>
                <div class="table-responsive">
                  <b-col md="6" offset-md="6">
                    <b-row no-gutters>
                      <b-col class="p-0">
                        <AvisoErros
                            v-bind:errors_array="errors_array"
                        ></AvisoErros>
                      </b-col>
                      <b-col class="p-0">
                        <label>Qtde. Notas</label>
                        <currency-input
                            class="form-control"
                            v-model="form.qtde_nfs"
                            placeholder="Qtde. Notas selecionadas"
                            disabled
                            :auto-decimal-mode="true"
                            :currency="{ prefix: ' ' }"
                            :distraction-free="getCurrency"
                        />
                      </b-col>
                      <b-col class="p-0">
                        <label>Vlr. total nfs </label>
                        <currency-input
                            class="form-control"
                            v-model="form.vlr_total_nfs"
                            placeholder="Vlr. total nfs"
                            disabled
                            :auto-decimal-mode="true"
                            :currency="{ prefix: 'R$ ' }"
                            :distraction-free="getCurrency"
                        />
                      </b-col>
                      <b-col class="p-0">
                        <label>Peso total bruto</label>
                        <currency-input
                            class="form-control"
                            v-model="form.vlr_total_peso_bruto"
                            placeholder="Peso total bruto"
                            disabled
                            :auto-decimal-mode="true"
                            :currency="{ prefix: ' ' }"
                            :distraction-free="getCurrency"
                        />
                      </b-col>
                      <b-col class="p-0">
                        <label>Volume total</label>
                        <currency-input
                            class="form-control"
                            v-model="form.vlr_total_volume"
                            placeholder="Total volume"
                            disabled
                            :auto-decimal-mode="true"
                            :currency="{ prefix: ' ' }"
                            :distraction-free="getCurrency"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                          v-if="loadingData"
                          text-fg-color="#ffffff"
                          message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <div>
                    <a
                        @click="searchAll()"
                        v-b-tooltip
                        title="Selecionar todas as páginas"
                        v-if="getPermissionFw('montagemcarga.index')"
                    ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0px 0px 5px 4px"
                    ></i
                    ></a>
                  </div>
                  <vuetable
                      ref="vuetable"
                      api-url="/api/montagemcarga"
                      :fields="fields"
                      :css="css"
                      :append-params="moreParams"
                      track-by="docfisId"
                      pagination-path="meta"
                      detail-row-component="montagemcarga-detalhes"
                      @vuetable:cell-clicked="onDetail"
                      @vuetable:load-error="onError"
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:loaded="onLoaded"
                  >
                    <template slot="doc" slot-scope="props">
                      <span
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc
                        "
                      >{{
                          props.rowData.cargaDoc.docCargaDoc.doc.numFiscal
                        }}</span
                      >
                    </template>
                    <template slot="dt_emi_cte" slot-scope="props">
                      <span
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc
                        "
                      >{{
                          formatDate(
                              props.rowData.cargaDoc.docCargaDoc.doc.dtEmi,
                              "DD/MM/YYYY HH:mm"
                          )
                        }}</span
                      >
                    </template>
                    <template slot="dt_previsao" slot-scope="props">
                      <span v-if="props.rowData.dtPrevisao != null">{{
                          formatDate(props.rowData.dtPrevisao, "DD/MM/YYYY")
                        }}</span>
                    </template>

                    <template slot="carga" slot-scope="props">
                      <span
                          v-if="
                          props.rowData.cargaBipDoc &&
                          props.rowData.cargaBipDoc.carga
                        "
                      >{{ props.rowData.cargaBipDoc.carga.numCarga }}</span
                      >
                    </template>

                    <template slot="status_montagem" slot-scope="props">
                      <span
                          class="badge badge-success"
                          v-if="
                          props.rowData.cargaBipDoc !== null &&
                          props.rowData.cargaBipDoc.status.valor == 1
                        "
                      >{{ props.rowData.cargaBipDoc.status.descr }}
                        {{ props.rowData.vlrTotalBips }}/{{
                          props.rowData.vlrTotalVolumes
                        }}</span
                      >
                      <span
                          class="badge badge-warning"
                          v-if="
                          props.rowData.cargaBipDoc !== null &&
                          props.rowData.cargaBipDoc.status.valor == 2 &&
                          props.rowData.statusBipMontagem != 4
                        "
                      >Em andamento {{ props.rowData.vlrTotalBips }}/{{
                          props.rowData.vlrTotalVolumes
                        }}</span
                      >
                      <span
                          class="badge badge-secondary"
                          v-if="
                          props.rowData.cargaBipDoc !== null &&
                          props.rowData.cargaBipDoc.status.valor == 3
                        "
                      >{{ props.rowData.cargaBipDoc.status.descr }}</span
                      >
                      <span
                          class="badge badge-success"
                          v-if="props.rowData.statusBipMontagem == 4"
                      >Finalizado</span
                      >
                      <span
                          class="badge badge-secondary"
                          v-if="props.rowData.cargaBipDoc == null"
                      >Sem carga iniciada</span
                      >

                      <span
                          class="badge badge-success"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.carga &&
                          props.rowData.cargaDoc.carga.tpCarga == 2 &&
                          props.rowData.cargaDoc.carga.status.valor == 1
                        "
                      >{{ props.rowData.cargaDoc.carga.status.descr }}</span
                      >
                      <span
                          class="badge badge-warning"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.carga &&
                          props.rowData.cargaDoc.carga.tpCarga == 2 &&
                          props.rowData.cargaDoc.carga.status.valor == 2
                        "
                      >{{ props.rowData.cargaDoc.carga.status.descr }}</span
                      >
                      <span
                          class="badge badge-info"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.carga &&
                          props.rowData.cargaDoc.carga.tpCarga == 2 &&
                          props.rowData.cargaDoc.carga.status.valor == 3
                        "
                      >{{ props.rowData.cargaDoc.carga.status.descr }}</span
                      >
                      <span
                          class="badge badge-danger"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.carga &&
                          props.rowData.cargaDoc.carga.tpCarga == 2 &&
                          props.rowData.cargaDoc.carga.status.valor == 4
                        "
                      >{{ props.rowData.cargaDoc.carga.status.descr }}</span
                      >
                      <span
                          class="badge badge-secondary"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.carga &&
                          props.rowData.cargaDoc.carga.tpCarga == 2 &&
                          props.rowData.cargaDoc.carga.status.valor == 5
                        "
                      >{{ props.rowData.cargaDoc.carga.status.descr }}</span
                      >
                      <span
                          class="badge badge-secondary"
                          v-if="
                          props.rowData.cargaDoc == null ||
                          (props.rowData.cargaDoc != null &&
                            props.rowData.cargaDoc.carga == null)
                        "
                      >Sem carga iniciada</span
                      >
                    </template>

                    <!--codigo abaixo usa o status da carga criada via bip-->
                    <!--                                  <template slot="status_montagem" slot-scope="props">-->
                    <!--                                    <span class="badge badge-success" v-if="props.rowData.carga_bip_doc!==null && props.rowData.carga_bip_doc.status.valor==1">{{ props.rowData.carga_bip_doc.status.descr}} {{props.rowData.vlrTotalBips}}/{{props.rowData.vlrTotalVolumes}}</span>-->
                    <!--                                    <span class="badge badge-warning" v-if="props.rowData.carga_bip_doc!==null && props.rowData.carga_bip_doc.status.valor==2 && props.rowData.statusBipMontagem!=4">Em andamento {{props.rowData.vlrTotalBips}}/{{props.rowData.vlrTotalVolumes}}</span>-->
                    <!--                                    <span class="badge badge-secondary" v-if="props.rowData.carga_bip_doc!==null && props.rowData.carga_bip_doc.status.valor==3">{{ props.rowData.carga_bip_doc.status.descr}}</span>-->
                    <!--                                    <span class="badge badge-success" v-if="props.rowData.statusBipMontagem==4">Finalizado</span>-->
                    <!--                                    <span class="badge badge-secondary" v-if="props.rowData.carga_bip_doc == null">Sem carga iniciada</span>-->
                    <!--                                    - -->
                    <!--                                    <span class="badge badge-success" v-if="props.rowData.carga_bip_doc && props.rowData.carga_bip_doc.carga && props.rowData.carga_bip_doc.carga.status.valor==1">{{ props.rowData.carga_bip_doc.carga.status.descr}}</span>-->
                    <!--                                    <span class="badge badge-warning" v-if="props.rowData.carga_bip_doc && props.rowData.carga_bip_doc != null && props.rowData.carga_bip_doc.carga && props.rowData.carga_bip_doc.carga.status.valor==2">{{ props.rowData.carga_bip_doc.carga.status.descr}}</span>-->
                    <!--                                    <span class="badge badge-info" v-if="props.rowData.carga_bip_doc && props.rowData.carga_bip_doc.carga && props.rowData.carga_bip_doc.carga.status.valor==3">{{ props.rowData.carga_bip_doc.carga.status.descr}}</span>-->
                    <!--                                    <span class="badge badge-danger" v-if="props.rowData.carga_bip_doc && props.rowData.carga_bip_doc.carga && props.rowData.carga_bip_doc.carga.status.valor==4">{{ props.rowData.carga_bip_doc.carga.status.descr}}</span>-->
                    <!--                                    <span class="badge badge-secondary" v-if="props.rowData.carga_bip_doc && props.rowData.carga_bip_doc.carga && props.rowData.carga_bip_doc.carga.status.valor==5">{{ props.rowData.carga_bip_doc.carga.status.descr}}</span>-->
                    <!--                                    <span class="badge badge-secondary" v-if="props.rowData.carga_bip_doc == null || props.rowData.carga_bip_doc != null && props.rowData.carga_bip_doc.carga==null || props.rowData.carga_bip_doc != null && props.rowData.carga_bip_doc==null">Sem carga iniciada</span>-->
                    <!--                                  </template>-->

                    <template slot="tp_operacao" slot-scope="props">
                      <span
                          class="badge badge-danger"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.tpOperacao
                            .valor == 1
                        "
                      >
                        <a
                            v-b-tooltip
                            v-if="props.rowData.cargaDoc.docCargaDoc"
                            :title="
                            props.rowData.cargaDoc.docCargaDoc.doc.tpOperacao
                              .descr
                          "
                        >ND</a
                        ></span
                      >
                      <span
                          class="badge badge-success"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.tpOperacao
                            .valor == 2
                        "
                      ><a
                          v-b-tooltip
                          :title="
                            props.rowData.cargaDoc.docCargaDoc.doc.tpOperacao
                              .descr
                          "
                      >Transf</a
                      ></span
                      >
                      <span
                          class="badge badge-warning"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.tpOperacao
                            .valor == 3
                        "
                      ><a
                          v-b-tooltip
                          v-if="props.rowData.cargaDoc.docCargaDoc"
                          :title="
                            props.rowData.cargaDoc.docCargaDoc.doc.tpOperacao
                              .descr
                          "
                      >LM</a
                      ></span
                      >
                    </template>
                    <template slot="tp_processo" slot-scope="props">
                      <a
                          v-b-tooltip
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso"
                          :title="
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                            .descr
                        "
                      >
                        <span
                            class="badge badge-danger"
                            v-if="
                            props.rowData.cargaDoc &&
                            props.rowData.cargaDoc.docCargaDoc &&
                            props.rowData.cargaDoc.docCargaDoc.doc &&
                            props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                              .valor == 1
                          "
                        >ND</span
                        >
                      </a>
                      <span
                          class="badge badge-success"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                            .valor == 2
                        "
                      >{{
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                              .descr
                        }}</span
                      >
                      <span
                          class="badge badge-warning"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                            .valor == 3
                        "
                      >{{
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                              .descr
                        }}</span
                      >
                      <span
                          class="badge badge-info"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                            .valor == 4
                        "
                      >{{
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                              .descr
                        }}</span
                      >
                      <span
                          class="badge badge-info"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                            .valor == 6
                        "
                      >{{
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                              .descr
                        }}</span
                      >
                      <span
                          class="badge badge-info"
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                            .valor == 7
                        "
                      >{{
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                              .descr
                        }}</span
                      >
                      <a
                          v-b-tooltip
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso"
                          :title="
                          props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                            .descr
                        "
                      >
                        <span
                            class="badge badge-secundary"
                            v-if="
                            props.rowData.cargaDoc &&
                            props.rowData.cargaDoc.docCargaDoc &&
                            props.rowData.cargaDoc.docCargaDoc.doc &&
                            props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso
                              .valor == 5
                          "
                        >Entr Dir</span
                        >
                      </a>
                    </template>
                    <template slot="cliente_nf" slot-scope="props">
                      <span
                      >{{ props.rowData.DocFiscalPartesEnv.desNome }} -
                        {{ props.rowData.DocFiscalPartesEnv.desCnpj }}
                      </span>
                    </template>
                    <template slot="redespacho_nf" slot-scope="props">
                      <span
                      >{{ props.rowData.DocFiscalPartesEnv.redNome }} -
                        {{ props.rowData.DocFiscalPartesEnv.redCnpj }}
                      </span>
                    </template>
                    <template slot="obs" slot-scope="props">
                      <span
                          v-if="
                          props.rowData.cargaBipDoc != null &&
                          props.rowData.cargaBipDoc.carga != null
                        "
                      >
                        {{ props.rowData.cargaBipDoc.carga.obs }}
                      </span>
                    </template>
                    <template slot="regiao" slot-scope="props">
                      <span
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.regiaoDespesa
                        "
                      >{{
                          props.rowData.cargaDoc.docCargaDoc.doc.regiaoDespesa
                              .cd
                        }}
                      </span>
                      <span
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.docRps !== null
                        "
                      >{{
                          props.rowData.cargaDoc.docCargaDoc.doc.docRps
                              .doc_rps_regiao
                        }}
                      </span>
                    </template>
                    <template slot="peso_bruto">
                      <span>{{ this.pesoBruto }}</span>
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                            v-if="
                            props.rowData.cargaBipDoc !== null &&
                            props.rowData.cargaBipDoc.carga != null &&
                            props.rowData.cargaBipDoc.carga.status.valor == 2
                          "
                            @click="onCreate(props.rowData, 2)"
                            v-b-tooltip
                            title="Adicionar nota fiscal a carga"
                        ><i class="fa fa-file"></i
                        ></a>
                        <a
                            v-if="
                            getPermissionFw(
                              'montagemcarga.alterartransportadora'
                            )
                          "
                            @click="
                            onEditTransportadora(props.rowData, null, null)
                          "
                            v-b-tooltip
                            title="Alterar Transportadora"
                        ><i class="fa fa-truck"></i
                        ></a>
                        <a
                            @click="onDetail(props.rowData, null, null)"
                            v-b-tooltip
                            title="Ver detalhes"
                        ><i class="fa fa-plus"></i
                        ></a>
                        <a
                            v-if="props.rowData.docFiscalUnidade.length > 1"
                            v-b-tooltip
                            :title="
                            'Transferencia de: ' +
                            props.rowData.docFiscalUnidade[
                              props.rowData.docFiscalUnidade.length - 2
                            ].descr
                          "
                        ><i class="fa fa-sign-in"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                          ref="paginationInfo"
                          :css="css.pagination"
                          info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                          ref="pagination"
                          :css="css.pagination"
                          @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MontagemCargaTransportadoraForm ref="montagemcargatransportadora">
      </MontagemCargaTransportadoraForm>
      <MontagemCargaForm ref="montagemcargaform"></MontagemCargaForm>
      <MontagemCargaObs ref="montagemcargaobs"></MontagemCargaObs>
    </div>
  </div>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import MontagemCargaFilterBar from "./MontagemCargaFilterBar";
import moment from "moment";
import accounting from "accounting";
import MontagemCargaDetalhes from "./MontagemCargaDetalhes";
import MontagemCargaTransportadoraForm from "./MontagemCargaTransportadoraForm";
import MontagemCargaForm from "./MontagemCargaForm";
import MontagemCargaObs from "./MontagemCargaObs";

Vue.component("montagemcarga-detalhes", MontagemCargaDetalhes);
Vue.component("montagemcargaobs", MontagemCargaObs);

export default {
  components: {
    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    MontagemCargaTransportadoraForm,
    MontagemCargaForm,
    MontagemCargaObs,
    "vuetable-filterbar": MontagemCargaFilterBar,
  },
  data() {
    return {
      dataExport: [],
      dados: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      pesoBruto: "",
      checkbox: [],
      errors_array: [],
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      optionsMeioTransp: [],
      optionsTipoCarga: [],
      optionsTipoNf: [],
      optionsMunicipio: [],
      optionsStatusCarga: [],
      optionsTpOperacao: [],
      optionsTpProcesso: [],
      optionsStatusBip: [],
      optionsUnidade: [],
      optionsRegiao: [],
      optionsUf: [],
      filter_data_store: {},
      filtros_form: new Form({
        num_carga: "",
        num_nf: "",
        num_fiscal_cte: "",
        status_bip: "",
        status_carga: "",
        dt_emi_ini: "",
        dt_emi_fim: "",
        dt_carga_ini: "",
        dt_carga_fim: "",
        cnpj_origem: "",
        observacao: "",
        cnpj_des_red: "",
        tp_operacao: "",
        tp_processo: "",
        municipio_emi: "",
        uf_emi: "",
        municipio_des_red: "",
        uf_des_red: "",
        unidade: "",
        redespacho: "",
        regiao: "",
        transferencia: "",
      }),
      form: new Form({
        vlr_total_nfs: 0,
        qtde_nfs: 0,
        vlr_total_peso_liquido: 0,
        vlr_total_peso_bruto: 0,
        vlr_total_volume: 0,
        docfis: [],
        vlr_total_nfs2: 0,
        vlr_total_peso_liquido2: 0,
        vlr_total_peso_bruto2: 0,
        vlr_total_volume2: 0,
      }),
      helpForm: new Form({
        recordCollection: [],
        docfisCollection: [],
        status: "",
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:doc",
          title: "Doc",
        },
        {
          name: "__slot:carga",
          title: "N° Carga",
        },
        {
          name: "__slot:status_montagem",
          title: "Status BIP / Carga",
        },
        {
          name: "__slot:tp_processo",
          title: "Processo",
        },
        {
          name: "__slot:tp_operacao",
          title: "Operação",
        },
        {
          name: "numFiscal",
          title: "N° NF",
        },
        {
          name: "serie",
          title: "Série",
        },
        {
          name: "__slot:dt_emi_cte",
          title: "Dt emissão",
        },
        {
          name: "__slot:dt_previsao",
          title: "Dt previsão",
        },
        {
          name: "__slot:cliente_nf",
          title: "Cliente NF",
        },
        {
          name: "__slot:redespacho_nf",
          title: "Redespacho",
        },
        {
          name: "__slot:regiao",
          title: "Região",
        },
        {
          name: "__slot:obs",
          title: "Obs",
        },
        {
          name: "pesoBruto",
          title: "Peso bruto",
          callback: "formatNumber",
        },
        {
          name: "qtdVolume",
          title: "Volume",
          callback: "formatNumber",
        },
        {
          name: "vlrTotalNfs",
          title: "Valor NF",
          callback: "formatNumber",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    searchAll(data_filter, tipo) {
      // if(this.$refs.vuetable.selectedTo.length > 0){
      //    this.$refs.vuetable.selectedTo = [];
      // }
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtros_form.cd_ocorrencia =
              this.filter_data_store.cd_ocorrencia;
          this.filtros_form.num_carga = this.filter_data_store.num_carga;
          this.filtros_form.num_nf = this.filter_data_store.num_nf;
          this.filtros_form.num_fiscal_cte =
              this.filter_data_store.num_fiscal_cte;
          this.filtros_form.status_bip = this.filter_data_store.status_bip;
          this.filtros_form.status_carga = this.filter_data_store.status_carga;
          this.filtros_form.dt_emi_ini = this.filter_data_store.dt_emi_ini;
          this.filtros_form.dt_emi_fim = this.filter_data_store.dt_emi_fim;
          this.filtros_form.dt_carga_ini = this.filter_data_store.dt_carga_ini;
          this.filtros_form.dt_carga_fim = this.filter_data_store.dt_carga_fim;
          this.filtros_form.cnpj_origem = this.filter_data_store.cnpj_origem;
          this.filtros_form.observacao = this.filter_data_store.observacao;
          this.filtros_form.cnpj_des_red = this.filter_data_store.cnpj_des_red;
          this.filtros_form.consulta_completa = this.filter_data_store.consulta_completa;
          this.filtros_form.tp_operacao = this.filter_data_store.tp_operacao;
          this.filtros_form.tp_processo = this.filter_data_store.tp_processo;
          this.filtros_form.municipio_emi =
              this.filter_data_store.municipio_emi;
          this.filtros_form.uf_emi = this.filter_data_store.uf_emi;
          this.filtros_form.municipio_des_red =
              this.filter_data_store.municipio_des_red;
          this.filtros_form.uf_des_red = this.filter_data_store.uf_des_red;
          this.filtros_form.unidade = this.filter_data_store.unidade;
          this.filtros_form.redespacho = this.filter_data_store.redespacho;
          this.filtros_form.regiao = this.filter_data_store.regiao;
          this.filtros_form.transferencia =
              this.filter_data_store.transferencia;
          this.filtros_form
              .post("/api/montagemcarga/all")
              .then((response) => {
                new ReturnApi(response, this, true, false, false);
                response.forEach((obj) => {
                  this.$refs.vuetable.selectedTo.push(parseFloat(obj.docfis_id));
                  this.form.vlr_total_nfs += obj.vlr_total_nfs;
                  this.form.vlr_total_peso_liquido += obj.peso_liquido;
                  this.form.vlr_total_peso_bruto += obj.peso_bruto_total;
                  this.form.vlr_total_volume += parseFloat(obj.qtd_volume);
                });
                this.loadingData = false;
              })
              .catch((errors) => {
                new ReturnApi(errors, this);
                this.loadingData = false;
              });
        } else {
          this.form.vlr_total_nfs = 0;
          this.form.vlr_total_peso_liquido = 0;
          this.form.vlr_total_peso_bruto = 0;
          this.form.vlr_total_volume = 0;
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      if (data_filter.redespacho == 2) {
        this.uf_des = data_filter.uf_des_red.value;
        this.municipio_des = data_filter.municipio_des_red.value;
        this.cnpj_destinatario = data_filter.cnpj_des_red;
        this.uf_red = "";
        this.cnpj_redespacho = "";
        this.municipio_red = "";
      } else {
        this.uf_red = data_filter.uf_des_red.value;
        this.cnpj_redespacho = data_filter.cnpj_des_red;
        this.municipio_red = data_filter.municipio_des_red.value;
        this.cnpj_destinatario = "";
        this.uf_des = "";
        this.municipio_des = "";
      }
      this.moreParams = {
        dt_emi_ini: data_filter.dt_emi_ini,
        dt_emi_fim: data_filter.dt_emi_fim,
        dt_pre_inicio: data_filter.dt_pre_inicio,
        dt_pre_fim: data_filter.dt_pre_fim,
        dt_carga_ini: data_filter.dt_carga_ini,
        dt_carga_fim: data_filter.dt_carga_fim,
        redespacho: data_filter.redespacho,
        transferencia: data_filter.transferencia,
        cnpj_origem: data_filter.cnpj_origem,
        observacao: data_filter.observacao,
        cnpj_destinatario: this.cnpj_destinatario,
        cnpj_redespacho: this.cnpj_redespacho,
        tp_operacao: data_filter.tp_operacao.value,
        tp_processo: data_filter.tp_processo.value,
        municipio_emi: data_filter.municipio_emi.value,
        municipio_des: this.municipio_des,
        municipio_red: this.municipio_red,
        uf_emi: data_filter.uf_emi.value,
        unidade: data_filter.unidade.value,
        regiao: data_filter.regiao,
        uf_des: this.uf_des,
        consulta_completa: data_filter.consulta_completa,
        uf_red: this.uf_red,
        num_carga: data_filter.num_carga,
        num_nf: data_filter.num_nf,
        num_fiscal_cte: data_filter.num_fiscal_cte,
        status_carga: data_filter.status_carga.value,
        status_bip: data_filter.status_bip.value,
      };
      if (JSON.stringify(this.moreParams) != "{}") {
        this.searchAll(this.moreParams, 2);
      }
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      this.$refs.vuetable.selectedTo = [];
      this.filter_data_store = {};
      this.form.vlr_total_nfs = 0;
      this.form.vlr_total_peso_liquido = 0;
      this.form.vlr_total_peso_bruto = 0;
      this.form.vlr_total_volume = 0;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport.push(this.$refs.vuetable.tableData);
      this.somaPesos();
      this.dataExport.forEach((obj2) => {
        obj2.forEach((obj3) => {
          this.dados.push({
            docfisId: obj3.docfisId,
            vlrTotalNfs: obj3.vlrTotalNfs,
            pesoLiquido: obj3.pesoLiquido,
            pesoBruto: obj3.pesoBruto,
            qtdVolume: obj3.qtdVolume,
          });
        });
      });
      this.$watch(
          () => {
            return this.$refs.vuetable.selectedTo;
          },
          (obj) => {
            this.somaValoresNfs(obj);
          }
      );
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    somaValoresNfs(obj) {
      // this.form.vlr_total_nfs = 0;
      // this.form.vlr_total_peso_liquido = 0;
      // this.form.vlr_total_peso_bruto = 0;
      // this.form.vlr_total_volume = 0;
      this.form.qtde_nfs = obj.length;
      this.form.vlr_total_nfs2 = 0;
      this.form.vlr_total_peso_liquido2 = 0;
      this.form.vlr_total_peso_bruto2 = 0;
      this.form.vlr_total_volume2 = 0;
      obj.forEach((item) => {
        this.data = this.dados.filter((item2) => item2.docfisId === item);
        this.form.vlr_total_nfs2 =
            parseFloat(this.data[0].vlrTotalNfs) + this.form.vlr_total_nfs2;
        this.form.vlr_total_peso_liquido2 =
            parseFloat(this.data[0].pesoLiquido) +
            this.form.vlr_total_peso_liquido2;
        this.form.vlr_total_peso_bruto2 =
            parseFloat(this.data[0].pesoBruto) + this.form.vlr_total_peso_bruto2;
        this.form.vlr_total_volume2 =
            parseFloat(this.data[0].qtdVolume) + this.form.vlr_total_volume2;
      });

      if (this.$refs.vuetable.selectedTo.length == 0) {
        this.form.vlr_total_nfs = 0;
        this.form.vlr_total_peso_liquido = 0;
        this.form.vlr_total_peso_bruto = 0;
        this.form.vlr_total_volume = 0;
      }

      if (this.form.vlr_total_nfs2 != 0) {
        this.form.vlr_total_nfs = this.form.vlr_total_nfs2;
      }
      if (this.form.vlr_total_peso_liquido2 != 0) {
        this.form.vlr_total_peso_liquido = this.form.vlr_total_peso_liquido2;
      }
      if (this.form.vlr_total_peso_bruto2 != 0) {
        this.form.vlr_total_peso_bruto = this.form.vlr_total_peso_bruto2;
      }
      if (this.form.vlr_total_volume2 != 0) {
        this.form.vlr_total_volume = this.form.vlr_total_volume2;
      }

      // obj.forEach((item, i) => {
      //   this.data = this.dataExport.filter((item2) => item2.docfis_id === item);
      //   this.form.vlr_total_nfs =
      //     parseFloat(this.data[0].doc_fiscal_vlr_total.vlr_total_nfe) +
      //     this.form.vlr_total_nfs;
      //   this.form.vlr_total_peso_liquido =
      //     parseFloat(this.data[0].peso_liquido) +
      //     this.form.vlr_total_peso_liquido;
      //   this.form.vlr_total_peso_bruto =
      //     parseFloat(this.data[0].peso_bruto) + this.form.vlr_total_peso_bruto;
      //   this.form.vlr_total_volume =
      //     parseFloat(this.data[0].qtd_volume) + this.form.vlr_total_volume;
      // });
    },
    onCreate(data, tipo) {
      this.$refs.montagemcargaform.onCreate(data, tipo);
    },
    onStore() {
      this.errors_array = "";
      this.errors_array = [];
      this.form.docfis = "";
      this.form.docfis = [];
      this.loadingData = true;
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.form.docfis.push({docfis_id: obj});
      });
      this.form
          .post("/api/montagemcarga/store")
          .then((response) => {
            new ReturnApi(response, this);
            this.onFilterReset();
            this.docfis = [];
            onEditarObs;
            this.loadingData = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            this.loadingData = false;
            this.errors_array = "";
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          });
    },
    onEditTransportadora(data) {
      this.$refs.montagemcargatransportadora.onEdit(
          data.doc_fiscal_transporte.doc_fiscal_transporte_transpor
      );
    },
    onEditTransportadoraLote() {
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.helpForm.docfisCollection.push(obj);
      });
      this.$refs.montagemcargatransportadora.onEditLote(
          this.helpForm.docfisCollection
      );
    },
    onEditarObs(data) {
      this.$refs.montagemcargaobs.onEdit(
          data.carga_bip_doc.carga.carga_id,
          data.carga_bip_doc.carga.obs
      );
    },
    somaPesos() {
      this.$refs.vuetable.tableData.forEach((item, i) => {
        this.vnPesoBruto = 0;
        this.vnPesoLiquido = 0;
        this.vnVolume = 0;
        // console.log(item);
        item.docFiscalTransporte.docFiscalTransporteVolume.forEach(
            (item2, i2) => {
              //this.$refs.vuetable.tableData[i].peso_bruto = 1000;
              this.$refs.vuetable.tableData[i].pesoBruto =
                  item2.pesoBruto + this.vnPesoBruto;
              this.$refs.vuetable.tableData[i].PesoLiquido =
                  item2.PesoLiquido + this.vnPesoLiquido;
              this.$refs.vuetable.tableData[i].qtdVolume =
                  item2.qtdVolume + this.vnVolume;
            }
        );
        if (item.cargaBipDoc !== null) {
          this.vnVlrTotalVolume = 0;
          this.vnVlrTotalVolumeBipados = 0;
          this.statusBipMontagem = 0;
          item.cargaBipDoc.cargaBipDocVolume.forEach((item2, i2) => {
            if (item2.statusMontagem.valor == 1) {
              this.vnVlrTotalVolumeBipados = this.vnVlrTotalVolumeBipados + 1;
            }
            /*
            if (item2.status_montagem.valor == 3) {
              //finalizado
              this.statusBipMontagem = 4;
            }*/
            this.vnVlrTotalVolume = this.vnVlrTotalVolume + 1;
          });
          this.$refs.vuetable.tableData[i].vlrTotalBips =
              this.vnVlrTotalVolumeBipados;
          this.$refs.vuetable.tableData[i].vlrTotalVolumes =
              this.vnVlrTotalVolume;
          /*if(this.statusBipMontagem == 4)
          {
            console.log('alterando status....')
            this.$refs.vuetable.tableData[i].statusBipMontagem = this.statusBipMontagem;
          }*/
          this.$refs.vuetable.tableData[i].vlrTotalBips =
              this.vnVlrTotalVolumeBipados;
          this.$refs.vuetable.tableData[i].vlrTotalVolumes =
              this.vnVlrTotalVolume;
          /*if (this.statusBipMontagem == 4) {
            this.$refs.vuetable.tableData[i].statusBipMontagem =
              this.statusBipMontagem;
          }*/
        }
      });
    },
    getUnidades(data) {
      var retorno = "";
      data.forEach((obj, i) => {
        if (i + 1 == data.length) {
          retorno = retorno + obj.unidade.descr;
        } else {
          retorno = retorno + obj.unidade.descr + " / ";
        }
      });
      return retorno;
    },
    getLivGeral() {
      this.helpForm
          .get("/api/montagemcarga/jsonlistgeral")
          .then((response) => {
            new ReturnApi(response, this, true, false, false);
            response.tipo_nf.forEach((obj) => {
              this.optionsTipoNf.push({label: obj.descr, value: obj.valor});
            });
            response.municipio.forEach((obj) => {
              this.optionsMunicipio.push({
                label: obj.nome + " - " + obj.uf.cd,
                value: obj.cd_ibge,
              });
            });
            response.uf.forEach((obj) => {
              this.optionsUf.push({label: obj.cd, value: obj.cd});
            });
            response.status_carga.forEach((obj) => {
              this.optionsStatusCarga.push({
                label: obj.descr,
                value: obj.valor,
              });
            });
            response.status_bip.forEach((obj) => {
              this.optionsStatusBip.push({label: obj.descr, value: obj.valor});
            });
            response.regiao.forEach((obj) => {
              this.optionsRegiao.push({
                label: obj.cd + "-" + obj.descr,
                regiao_id: obj.regiao_id,
                value: obj.regiao_id,
              });
            });
            response.tp_operacao.forEach((obj) => {
              this.optionsTpOperacao.push({label: obj.descr, value: obj.valor});
            });
            response.tp_processo.forEach((obj) => {
              this.optionsTpProcesso.push({label: obj.descr, value: obj.valor});
            });
            response.unidade.forEach((obj) => {
              this.optionsUnidade.push({
                label: obj.descr,
                value: obj.unidade_id,
              });
            });
            this.optionsStatusCarga.push({
              label: "Sem carga iniciada",
              value: 99,
            });
            this.optionsStatusBip.push({
              label: "Sem carga iniciada",
              value: 99,
            });
            this.$events.fire("load-json");
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.docfisId);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  },
};
</script>